import Cookies from 'js-cookie'

Cookies.set('sameSite', 'strict')
Cookies.set('secure', process.env.NODE_ENV === 'production' ? 'true' : 'false', {
  secure: process.env.NODE_ENV === 'production',
})

type StorageOptions = {
  // Expire time in ms
  expireIn: number
}

export type Storage = {
  get<T>(key: string): T
  set<T>(key: string, value: T, options?: StorageOptions): void
  unset<T>(key: string): T
}

export const CookieStorage: Storage = {
  get<T>(key: string): any {
    const value = Cookies.get(key)
    if (typeof value === 'undefined') {
      return
    }
    return <T>JSON.parse(value)
  },
  set<T>(key: string, value: T, options: StorageOptions): void {
    let cookieAttributes: Cookies.CookieAttributes = {}
    if (window.location.protocol === 'https:') {
      cookieAttributes = {
        secure: true,
        sameSite: 'none',
      }
    }
    cookieAttributes.expires = (options.expireIn || 3600) / 3600
    Cookies.set(key, JSON.stringify(value), cookieAttributes)
  },
  unset<T>(key: string): any {
    const val = CookieStorage.get<T>(key)

    Cookies.remove(key)

    return val
  },
}
